// Generated file : do not modify
export enum ArticleItemTypes
{
  NONE = 0,
  ETABLISSEMENT,
  REPRESENTANT,
  SALARIE,
  GENERATED_PLANNING,
  GENERATED_REMUNERATION,
  ITEM
};

import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Items des articles de contrat
export default class ArticleItem  {
  // Identifiant unique
  public id: number;
  // Texte du paragraphe
  public texte: string;
  // Commentaire
  public commentaire: string;
  // Type d'item
  public type: ArticleItemTypes;
  // Article associé
  public articleId: number;
  // position dans l'article'
  public ordre: number;
  // si faux, n'affiche le paragraphe que si les paramètres sont trouvés
  public requis: boolean;
  // Conventions applicables (vide = toutes)
  public conventionIds: number[];
  // Emplois applicables (vide = tous)
  public metierIds: number[];
  // Texte du paragraphe
  public texteHtmlId: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.texte = '';
    this.commentaire = '';
    this.type = ArticleItemTypes.NONE;
    this.articleId = 0;
    this.ordre = 0;
    this.requis = false;
    this.conventionIds = [];
    this.metierIds = [];
    this.texteHtmlId = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: ArticleItem): ArticleItem {
    const newArticleItem: ArticleItem = new ArticleItem();
    newArticleItem.id = obj.id;
    newArticleItem.texte = obj.texte;
    newArticleItem.commentaire = obj.commentaire;
    newArticleItem.type = obj.type;
    newArticleItem.articleId = obj.articleId;
    newArticleItem.ordre = obj.ordre;
    newArticleItem.requis = obj.requis;
    newArticleItem.conventionIds = JSON.parse(JSON.stringify(obj.conventionIds));
    newArticleItem.metierIds = JSON.parse(JSON.stringify(obj.metierIds));
    newArticleItem.texteHtmlId = obj.texteHtmlId;
    newArticleItem.canUpdate = obj.canUpdate;
    newArticleItem.canDelete = obj.canDelete;
    newArticleItem.display = obj.display;
    newArticleItem.clientId = obj.clientId;
    newArticleItem.notifDefType = obj.notifDefType;
    return newArticleItem;
  }

  public toJsonArticleItem (): string {
    const json = {
      texte: this.texte,
      commentaire: this.commentaire,
      type: this.type,
      articleId: this.articleId,
      ordre: this.ordre,
      requis: this.requis,
      conventionIds: this.conventionIds,
      metierIds: this.metierIds,
      texteHtmlId: this.texteHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromArticleItem (obj: ArticleItem): void {
    this.id = obj.id;
    this.texte = obj.texte;
    this.commentaire = obj.commentaire;
    this.type = obj.type;
    this.articleId = obj.articleId;
    this.ordre = obj.ordre;
    this.requis = obj.requis;
    this.conventionIds = obj.conventionIds;
    this.metierIds = obj.metierIds;
    this.texteHtmlId = obj.texteHtmlId;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareArticleItem (value: ArticleItem): boolean {
    return (this.toJsonArticleItem() == value.toJsonArticleItem());
  }

  public cloneArticleItem (): ArticleItem {
    return ArticleItem.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(articleItems: ArticleItem[]) {
  }
}
